const { show, confirmDialogData } = useConfirm();

export default () => {
    const cancel = async (id: number) => {
        const confirmed = await show({
            type: 'danger',
            header: 'Cancel payment request',
            message: 'Are you sure you want to cancel this payment request?',
            confirm: 'Cancel',
        });

        if (confirmed) {
            router.post(
                route('kiosk.payment-requests.cancel.store', {
                    paymentRequest: id,
                }),
                {},
                {
                    preserveScroll: true,
                    onSuccess: () => {
                        create({
                            title: 'Payment request canceled',
                            type: 'success',
                        });
                    },
                    onError: (e) => {
                        create({
                            title: e.message || 'Payment request not canceled',
                            type: 'error',
                        });
                    },
                }
            );
        }
    };

    const sendEmail = async (id: number) => {
        const confirmed = await show({
            type: 'info',
            header: 'Send email',
            message:
                'Are you sure you want to send an email with payment request to the owner?',
            confirm: 'Send email',
            hasCheckbox: true,
            checkboxData: {
                label: 'Send reminder with [Action Required] in the subject',
                name: 'reminder',
                checked: false,
            },
        });

        if (confirmed) {
            try {
                const result = await axios.post(
                    route('kiosk.payment-requests.email.store', {
                        paymentRequest: id,
                    }),
                    {
                        reminder:
                            confirmDialogData.value?.checkboxData?.checked,
                    }
                );

                if (result.data.success) {
                    create({
                        title: 'Email sent',
                        type: 'success',
                    });
                }
            } catch (e) {
                return;
            }
        }
    };

    return {
        cancel,
        sendEmail,
    };
};
